import React from 'react'
import QuoteRequestModalBlog from './quote-request-modal-blog';

export default class ServicesDumpsters extends React.Component {
    constructor(props) {
        super(props)
        this.commercialProjectType = "509";
        this.services = [
            {
                title: 'Temporary Dumpster Rental',
                code: 'dumpster',
                ondeffCode: 'priceAndAvailabilityForm',
                showButton: true,
                startVisible: false
            },
            {
                title: 'Full Service Junk Removal',
                code: 'junk-removal',
                ondeffCode: 'junkRemovalQuoteRequest',
                showButton: true,
                startVisible: false
            },
            {
                title: 'Permanent Commercial Waste',
                code: 'comercial-trash-service',
                initialFormData: [{ key: "project_type", value: this.commercialProjectType }],
                ondeffCode: 'commercialWasteQuoteRequest',
                showButton: true,
                startVisible: false
            }
        ]
        this.state =
        {
            showModal: false
        }
    }

    changeShowModal = () => {
        this.setState({showModal: !this.state.showModal})
    }

    render() {
            return (

                <div className="services mb-5">
                    <div className="card">
                        <h3>Select the Service You Need</h3>
                        {this.services.map(service => (
                            <QuoteRequestModalBlog 
                                label={service.title}
                                code={service.code}
                                ondeffCode={service.ondeffCode}
                                showButton={service.showButton}
                                startVisible={service.startVisible}
                                initialFormData={service.initialFormData}
                            />
                        ))}
                    </div>
                </div>

            )
    }

}
